import { render } from "./PreloaderComp.vue?vue&type=template&id=6ced0e4a"
import script from "./PreloaderComp.vue?vue&type=script&lang=js"
export * from "./PreloaderComp.vue?vue&type=script&lang=js"

import "./PreloaderComp.vue?vue&type=style&index=0&id=6ced0e4a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__